import { useAuth } from "@/hooks/use-auth";
import { canAccessProtectedAppPath, canManageUsers } from "@shared/platform/access-control";
import { Loader2 } from "lucide-react";
import { Redirect, Route } from "wouter";

import { pathWithSearch, signInPathFor } from "@/lib/return-to";
import { PROTECTED_ROUTE_COPY } from "@/lib/ui-labels";
export function ProtectedRoute({
  path,
  component: Component,
}: {
  path: string;
  component: () => React.JSX.Element;
}) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-border" />
        </div>
      </Route>
    );
  }

  if (!user) {
    return (
      <Route path={path}>
        <Redirect to={signInPathFor(pathWithSearch(window.location))} />
      </Route>
    );
  }

  if (!canAccessProtectedAppPath(user.role, path)) {
    return (
      <Route path={path}>
        <Redirect to="/" />
      </Route>
    );
  }

  return <Route path={path} component={Component} />;
}

export function AdminRoute({
  path,
  component: Component,
}: {
  path: string;
  component: () => React.JSX.Element;
}) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-border" />
        </div>
      </Route>
    );
  }

  if (!user) {
    return (
      <Route path={path}>
        <Redirect to={signInPathFor(pathWithSearch(window.location))} />
      </Route>
    );
  }

  if (!canManageUsers(user.role)) {
    return (
      <Route path={path}>
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <h1 className="text-2xl font-bold mb-4">{PROTECTED_ROUTE_COPY.accessDenied}</h1>
          <p className="text-muted-foreground text-center mb-6">
            {PROTECTED_ROUTE_COPY.youNeedAdministratorPrivilegesToAccess}
          </p>
          <Redirect to="/" />
        </div>
      </Route>
    );
  }

  return <Route path={path} component={Component} />;
}
